import { render, staticRenderFns } from "./CircleArrow.vue?vue&type=template&id=bd267d0c&scoped=true"
import script from "./CircleArrow.vue?vue&type=script&lang=js"
export * from "./CircleArrow.vue?vue&type=script&lang=js"
import style0 from "./CircleArrow.vue?vue&type=style&index=0&id=bd267d0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd267d0c",
  null
  
)

export default component.exports